import React from 'react';
import { Brain, Activity, Target } from 'lucide-react';

interface WorkoutOverviewProps {
  type: string;
  targetStrain: number;
  recovery: number;
  currentStrain: number;
}

export function WorkoutOverview({ type, targetStrain, recovery, currentStrain }: WorkoutOverviewProps) {
  const isRecommended = recovery >= 70 && (targetStrain + currentStrain) <= 21;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Brain className="w-5 h-5 text-primary" />
        <h2 className="font-semibold">Workout Overview</h2>
      </div>

      <div className="bg-muted/30 p-4 rounded-lg space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Activity className="w-4 h-4 text-primary" />
            <span className="font-medium">{type}</span>
          </div>
          <div className={`text-sm ${isRecommended ? 'text-success' : 'text-warning'}`}>
            {isRecommended ? 'Recommended' : 'Caution'}
          </div>
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Target Strain</span>
            <div className="flex items-center gap-2">
              <Target className="w-4 h-4 text-primary" />
              <span>{targetStrain.toFixed(1)}</span>
            </div>
          </div>

          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Current Daily Strain</span>
            <span>{currentStrain.toFixed(1)}</span>
          </div>

          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Projected Total Strain</span>
            <span>{(currentStrain + targetStrain).toFixed(1)}</span>
          </div>
        </div>

        <div className="text-sm text-muted-foreground">
          {isRecommended
            ? `With ${recovery}% recovery, you're well-prepared for this workout's intensity.`
            : `Consider a lighter workout with ${recovery}% recovery to optimize adaptation.`
          }
        </div>
      </div>
    </div>
  );
}